import { Component } from "preact";
import style from "./style";
import common from "../../../utils/common";
import { locale } from "../../../utils/i18n";
import _constant from "../../../utils/constants";
import { logEvent } from "../../../utils/logger";

export default class FooterLink extends Component {
  render() {
    return (
      <div className={style["footer-inner"]}>
        {this.props.triggerJSCheckout ? <img
          className="float-l secure-img"
          src={`${common.getStaticPath()}/assets/secure.png`}
          height="20"
          alt="business logo"
        /> : <img
          className="float-l ptm-bsng-log"
          src={`${common.getStaticPath()}/assets/logo-business.png`}
          height="20"
          alt="business logo"
        />}
        {this.props.triggerJSCheckout ? <span className={style["footer-txt"]}>
          {`100% Secure Payments `}<span style={{fontWeight: "bold"}}>{`Powered by `}</span>
          <a
            className={style["business-link"]}
            rel="noopener noreferrer"
            href={_constant.PAYTM_BUSINESS_LINK_URL}
            target="_blank"
            onClick={() => {
              logEvent({ eventType: "paytm_business_link" });
            }}
          >
            <img height="11" className={style["ptm-logo"]} src={`${common.getStaticPath()}/assets/paytm-logo-blue.png`} alt="Paytm" />
          </a>
        </span> : <span className={style["footer-txt"]}>
          {locale("footer.visit.payment.link")}{" "}
          <a
            className={style["business-link"]}
            rel="noopener noreferrer"
            href={_constant.PAYTM_BUSINESS_LINK_URL}
            target="_blank"
            onClick={() => {
              logEvent({ eventType: "paytm_business_link" });
            }}
          >
            {`business.paytm.com/payment-link`} 
          </a>
        </span>}

        <img className="float-r hide-m" src={`${common.getStaticPath()}/assets/pro.png`} height="20" alt="logos" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/footerlink/index.js